/**
 * Sign-out reset registry.
 *
 * authStore must clear per-user state owned by heavy, lazily-loaded stores
 * (the design editor's, which pulls in Konva). Importing those stores directly
 * dragged ~280KB of Konva into the eager bundle on EVERY page just so logout
 * could reset state that, on those pages, was never created.
 *
 * Instead each such store registers its own reset when it loads. If the store
 * was never loaded there is nothing to reset, and nothing is downloaded.
 */
type ResetFn = () => void;

const resets = new Set<ResetFn>();

/** Register a sign-out reset. Returns an unregister function. */
export function registerSignOutReset(fn: ResetFn): () => void {
  resets.add(fn);
  return () => resets.delete(fn);
}

/** Run every registered reset. One thrower can't block the others or sign-out. */
export function runSignOutResets(): void {
  for (const fn of resets) {
    try {
      fn();
    } catch {
      // A store that fails to reset must not prevent sign-out.
    }
  }
}
